'use strict';

angular.module('ringbaPortal.services').factory('callPlanService', callPlanService);

// GET /{accountid}/callplan
// Gets a list of Call Plans for the given account
// POST /{accountid}/callplan
// creates a new call plan with the given information
// GET /{accountid}/callplan/{id}
// Gets a call plan for the given account
// PATCH /{accountid}/callplan/{id}
// updates the attributes of the call plan
// GET /{accountid}/callplan/{id}/callRoute
// gets the call routes fro the given plan
// POST /{accountid}/callplan/{id}/callRoute
// DELETE /{accountid}/callplan/{id}/callRoute/{routeId}

function callPlanService($http, ngAuthSettings, promiseCacheService) {
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const service = {
    getCallPlans: getCallPlans,
    getCallPlansBasic: getCallPlansBasic,
    getCallPlan: getCallPlan,
    createCallPlan: createCallPlan,
    updateCallPlan: updateCallPlan,
    linkToItem: linkToItem,
    unlinkItem: unlinkItem,
    getCallRoutes: getCallRoutes,
    addRoute: addRoute,
    deleteRoute: deleteRoute,
    getInboundReferences: getInboundReferences,
    deleteCallPlan: deleteCallPlan,
    duplicateCallPlan: duplicateCallPlan
  };

  return service;

  function getCallPlans(accountId) {
    const url = _serviceBaseUrl(accountId);
    // 10 seconds cache to avoid issues if multiple ivr nodes query it
    return promiseCacheService.getCallWithCachedPromise('getCallPlans' + accountId, url, 10).then(function(result) {
      return result.data.callPlans;
    });
  }

  function getCallPlansBasic(accountId) {
    const url = _serviceBaseUrl(accountId) + '/basic';
    // 10 seconds cache to avoid issues if multiple ivr nodes query it
    return promiseCacheService.getCallWithCachedPromise('getCallPlansBasic' + accountId, url, 10).then(function(result) {
      return result.data.callPlans;
    });
  }


  function getCallPlan(accountId, callPlanId) {
    const url = _serviceBaseUrl(accountId, callPlanId);
    return $http.get(url).then(function(result){ return result.data.callPlan; });
  }

  function createCallPlan(accountId, name, routingType) {
    const url = _serviceBaseUrl(accountId);
    const data = {
      name: name,
      routingType: routingType
    };
    return $http.post(url, data).then(function(result){ return result.data; });
  }

  function updateCallPlan(accountId, callPlan) {
    const url = _serviceBaseUrl(accountId, callPlan.id);
    return $http.patch(url, _sanitizeCallPlanForUpdate(callPlan));
  }

  function addRoute(accountId, callPlanId, routeId) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/callRoute';
    return $http.post(url, {
      callRouteId: routeId
    });
  }

  function deleteRoute(accountId, callPlanId, routeId) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/callRoute/' + routeId;
    return $http.delete(url);
  }

  function getCallRoutes(accountId, callPlanId) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/callRoute';
    return $http.get(url);
  }

  function getInboundReferences(accountId, callPlanId) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/InboundReferences';
    return $http.get(url);
  }

  function deleteCallPlan(accountId, callPlanId) {
    const url = _serviceBaseUrl(accountId, callPlanId);
    return $http.delete(url);
  }

  function duplicateCallPlan(accountId, callPlan) {
    const url = _serviceBaseUrl(accountId) + '/duplicate/' + callPlan.id;
    return $http.post(url);
  }

  function linkToItem(accountId, callPlanId, item) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/link';
    return $http.patch(url, item);
  }

  function unlinkItem(accountId, callPlanId, item) {
    const url = _serviceBaseUrl(accountId, callPlanId) + '/unlink';
    return $http.patch(url, item);
  }

  function _serviceBaseUrl(accountId, callPlanId) {
    return serviceBaseUri + accountId + '/callplan' + (callPlanId ? '/' + callPlanId : '');
  }

  function _sanitizeCallPlanForUpdate(callPlan) {
    const sanitizedPlan = angular.copy(callPlan);
    delete sanitizedPlan.routes;
    return sanitizedPlan;
  }
}
